module.exports = __webpack_public_path__ + "assets/img/car1.6f03bf86.png";